import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useCustomStyles from "../../hooks/useCustomStyles";
//import { customStyles } from '../../assets/styles/notificationForm';
import { selectState } from "../../store/slices/themeSlice";
import { AppDispatch, RootState } from "../../store/store";
import {
  getAdvisorsAction,
  getClientsAction,
  getClientStatus,
  getSubscriberSummary,
} from "../../store/actions/clientsActions";

import { ClientType, PendingClientType } from "../../store/slices/clientsSlice";
import { useNavigate } from "react-router-dom";
import { jsDate, normalizeBusinessName } from "../../utils";
import {
  CLIENT_COLUMNS,
  CLIENT_ID_COLUMNS,
  PENDING_CLIENT_COLUMNS,
  withDescriptions,
} from "../../utils/columnDescriptions";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import TableComponent from "./components/fff";
import HeaderTabs from "./components/HeaderTabs";
import { ContractType } from "../../store/actions/accessCodeActions";
import CustomButton from "../../components/CustomButton";
import AddNewClientModal from "./components/AddNewClientModal";
import ShareAccessCodeClientModal from "./components/ShareAccessCodeClientModal";
import ConfirmModal from "./components/ConfirmModal";
import { ClientActivity } from "./components/ActiveClientInfo";
import { fetchUserActivity } from "../../api/revenuCatApis";
import { ErrorTriage, getUsersLastLogin } from "../../api/awsApis";
import { fetchPartnerClientIds } from "../../store/actions/partnerClientIdsActions";
import { PartnerClientId } from "../../store/slices/partnerClientIdsSlice";
import DynamicTable from "./components/CustomTable";
import PartnerClientIdModal from "./components/ClientIdModal";
import CancelClientIdModal from "./components/CancelClientIdModal";
import { Pencil, Ban } from "lucide-react";
import { BulkUploadClientIds } from "../../components/BulkUploadClientIds";
import SearchInput from "./components/SearchInput";
import { Business } from "../../store/slices/businessSlice";
import { fetchBusinesses } from "../../store/actions/businessActions";
import ClientsAnalytics from "./components/ClientsAnalytics";

const Clients = () => {
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(accessCodesStyles, theme);
  const { user } = useSelector((state: RootState) => state.auth_slice);
  const isElisyan = user?.business?.name === "elisyan";
  const isAurum =
    user?.business?.name === "aurum" || user?.business?.name === "aurum-test";
  const { clients, subscribers, pendingClients, clientsActivity } = useSelector(
    (state: RootState) => state.clients_slice
  );
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [isRemoveLicenseModalOpen, setIsRemoveLicenseModalOpen] =
    useState(false);
  const [clientActivities, setClientActivities] = useState<
    Record<string, ClientActivity>
  >({});

  const [usersLastLogin, setUsersLastLogin] = useState<Record<string, { loginTime: number | Date | string } > | undefined>(undefined);

  ///////////////////// For ClientId Reference/////////////////////
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const {businesses } = useSelector((state: any) => state.accessCode_slice);
  const { businesses: businessList } = useSelector((state: RootState) => state.business_slice);
  const { items, loading, error, lastDocId, page , total} = useSelector((state: RootState ) => state.partnerClientIds_slice);
  const [selectedClient, setSelectedClient] = useState<PartnerClientId | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddNewClientIdModalOpen, setIsAddNewClientIdModalOpen] = useState(false);
  const [cancelTarget, setCancelTarget] = useState<PartnerClientId | null>(null);

  const [userBusiness, setUserBusiness] = useState<Business | null>(null);
  const [need_client_id, setNeedClientId] = useState((userBusiness?.need_client_id || user?.business?.name === 'elisyan') ? true : false);


  function formatDate(dateInput: string | Date | number | undefined): string {
    if (!dateInput) return "Never";

    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return "Never";

    return new Intl.DateTimeFormat("en-UK", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  }
  useEffect(() => {
    if (!clients) {
      if (user?.business?.name) {
        const isAdmin = user.roles.includes("master");
        let businessNames: string[];

        switch (user.business.name) {
          case "sopher":
            businessNames = isAdmin
              ? ["sopher", "SOPHER_ACCOUNTING"]
              : ["sopher"];
            break;

          case "sopher-test": {
            // console.log(
            //   "sopher-test business name from get clients",
            //   user.email,
            //   user.user_name,
            //   user.business.name
            // );
            businessNames = isAdmin
              ? ["sopher-test", "SOPHER_ACCOUNTING_TEST"]
              : ["sopher-test"];
            break;
          }

          default: {
            // console.log(
            //   "default business name from get clients",
            //   user.email,
            //   user.user_name,
            //   user.business.name
            // );
            businessNames = [user.business.name];
            break;
          }
        }
        dispatch(getClientsAction({ business_names: businessNames, token: user.token  }));
        dispatch(getAdvisorsAction({ business_names: businessNames }));
      }
    } else {
      if(clients && clients.length > 0)
      dispatch(
        getSubscriberSummary({
          userIds: clients?.map((client) => client.app_user_id),
        })
      );
    }
  }, []);
  // Function to fetch activities for multiple clients
  // const fetchAllClientActivities = React.useCallback(
  //   async (clients: ClientType[]) => {
  //     if (!clients || clients.length === 0) return;

  //     try {
  //       const appUserIds = clients.map((client) => client.app_user_id);
  //       const res = await fetchUserActivity(appUserIds);

  //       if (res.success?.length) {
  //         setClientActivities((prev) => ({
  //           ...prev,
  //           ...res.success.reduce((acc, activity) => {
  //             if (activity.id) acc[activity.id] = activity;
  //             return acc;
  //           }, {} as Record<string, ClientActivity>),
  //         }));
  //       }
  //     } catch (e) {
  //       console.error("Error fetching user activities:", e);
  //     }
  //   },
  //   []
  // );

//   const getAllUsersActivity = async () => {
//     if (clients && clients.length > 0) {
//       try{
//         const appUserIds = clients.map((client) => client.app_user_id);
//         const res = await getUsersLastLogin(
//           appUserIds
//         );

//         console.warn("Users Last Login Response:", res);

//         if (res.status === "success") {
//           setUsersLastLogin((prev) => {
//             const updatedLogins = prev?  { ...prev } : {};
//             for(const [userId, loginTime] of Object.entries(res.usersWithLastActivity || {})){
//               console.log('userId and loginTime', userId, loginTime, new Date(
//                 Number(loginTime) * 1000 // Convert seconds to milliseconds
//               ));
//               updatedLogins[userId] = { loginTime: 
//                 new Date(
//                   Number(loginTime.loginTime) * 1000 // Convert seconds to milliseconds
//                 )
//                };
//             }
//             return updatedLogins;
//           });
//           if(res.usersWithNoSnapshots && res.usersWithNoSnapshots.length > 0){
//             const resRC = await fetchUserActivity(res.usersWithNoSnapshots);
//             if (resRC.success?.length) {
//               setUsersLastLogin((prev) => {
//                 const updatedLogins = prev?  { ...prev } : {};
//                 resRC.success.forEach((activity) => {
//                   if(activity.id){
//                     updatedLogins[activity.id] = { loginTime: 
//                       new Date( activity.last_seen_at 
//                     )  
//                     };
//                   }
//                 });
//                 return updatedLogins;
//               });
//             }
//           }
//         }
//       }
//       catch(e){
//         console.error("Error fetching user activities:", e);
//       }
//   }
// };

  // // Call this when your clients data loads or changes
  // useEffect(() => {
  //   if (clients && clients.length > 0) {
  //     fetchAllClientActivities(clients);
  //   }
  // }, [clients]);

  // useEffect(() => {
  //   getAllUsersActivity();
  // }, [clients]);

  const handleClientClick = (
    client: ClientType | ContractType | ErrorTriage
  ) => {
    //console.log(JSON.stringify(client));
    navigate(`/clientDetails`, { state: { client } });
  };

  const [selectedTab, setSelectedTab] = useState("active"); // Default to pending
  const [pendingClient, setPendingClient] = useState<PendingClientType | null>(
    null
  );


  const [filteredClients, setFilteredClients] = useState<ClientType[]>([]);
  const [isAddNewClientModalOpen, setIsAddNewClientModalOpen] = useState(false);
  const [isShareAccessCodeModalOpen, setIsShareAccessCodeModalOpen] =
    useState(false);

  let columnsBySelectedTab: {
    key: string;
    label: string;
    sortable: boolean;
  }[] = [];
  if (selectedTab === "active") {
    columnsBySelectedTab = [
      { key: "created_at", label: "Created Date", sortable: true },
      { key: "user_name", label: "Name", sortable: true },
      { key: "email", label: "Email", sortable: true },
      { key: "clientId", label: "Client Id", sortable: true },
      { key: "status", label: "Status", sortable: false },
      ...(isAurum
        ? []
        : [{ key: "last_seen", label: "Last Activity", sortable: false }]),
      { key: "expire_at", label: "Expiry Date", sortable: false },
      // { key: "business_name", label: "Business Name", sortable: false },
    ];
  } else {
    columnsBySelectedTab = [
      { key: "pending_user_name", label: "Name", sortable: true },
      { key: "pending_email", label: "Email", sortable: true },
      { key: "clientId", label: "Client Id", sortable: true },
      // { key: "business_name", label: "Business Name", sortable: false },
    ];
  }
  // const [selectedTab, setSelectedTab] = useState<string>("active");
  if (
    user?.business?.name == "elisyan" ||
    user?.business?.name === "sopher" ||
    user?.business?.name === "sopher-test"
  ) {
    columnsBySelectedTab.push({
      key: "business_name",
      label: "Business Name",
      sortable: false,
    });
  }
  const tabs = [
    { value: "active", label: "Active" },
    { value: "pending", label: "Pending" },
    ...(isElisyan ? [{ value: "analytics", label: "Analytics" }] : []),
  ];

  const cancelAddNewClientModal = () => {
    setIsAddNewClientModalOpen(false);
  };
  const confirmAddNewClientModal = (client: PendingClientType) => {
    setPendingClient(client);
    setIsShareAccessCodeModalOpen(true);
    setIsAddNewClientModalOpen(false);
  };
  const cancelShareAccessCodeModal = () => {
    setIsShareAccessCodeModalOpen(false);
  };
  useEffect(() => {
    if (clients && subscribers) {
      const filtC = clients.map(
        (client) => {
        const createdAtRaw =
          typeof client.created_at === "string" ||
          client.created_at instanceof Date
            ? new Date(client.created_at)
            : jsDate(client.created_at);
        const createdAtDate =
          createdAtRaw && !isNaN(createdAtRaw.getTime()) ? createdAtRaw : null;
        const expires_date =
          subscribers[client.app_user_id]?.entitlements &&
          Object.values(subscribers[client.app_user_id]?.entitlements)[0]
            ?.expires_date;
        const expireAtDate = expires_date ? new Date(expires_date) : null;
        return {
          ...client,
          verificationStatus: "active" as const,
          clientId: client.clientId,

          status: getClientStatus(client.app_user_id, subscribers),
          business_name: normalizeBusinessName(client.business_name),
          created_at_raw: createdAtDate, // Keep raw date
          created_at:
            createdAtDate && !isNaN(createdAtDate.getTime())
              ? new Intl.DateTimeFormat("en-UK", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }).format(createdAtDate)
              : "N/A",
          expire_at_raw: expireAtDate, // Keep raw date
          expire_at:
            expireAtDate && !isNaN(expireAtDate.getTime())
              ? new Intl.DateTimeFormat("en-UK", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }).format(expireAtDate)
              : "N/A",
          last_seen_raw: clientsActivity && clientsActivity[client.app_user_id] && clientsActivity[client.app_user_id].loginTime? clientsActivity[client.app_user_id].loginTime : clientActivities[client.app_user_id]?.last_seen_at, // Keep raw date
          last_seen: clientsActivity && clientsActivity[client.app_user_id] && clientsActivity[client.app_user_id].loginTime && clientsActivity[client.app_user_id].loginTime != null ?formatDate( new Date(clientsActivity[client.app_user_id].loginTime)) :
               "...",
        };
      });
      setFilteredClients(filtC);
    }
  }, [clients, subscribers, clientActivities, clientsActivity]);

  useEffect(() => {
    console.log("Filtered Clients:", filteredClients);
    console.log('usersLastLogin', usersLastLogin)
  },[filteredClients, usersLastLogin]);
  const handleRemoveLicense = () => {
    setIsRemoveLicenseModalOpen(false);
  };
  const dropdowns = [
    {
      options: [
        { value: "bassam", key: "1" },
        { value: "hamz", key: "2" },
        { value: "ali", key: "3" },
        { value: "mohammed", key: "4" },
      ],
      initialState: "Type",
    },
    {
      options: [
        { value: "Admin", key: "1" },
        { value: "User", key: "2" },
        { value: "Guest", key: "3" },
      ],
      initialState: "Role",
    },
  ];
  

  //******************************* For ClientId Reference ******************************************//
  
    const confirmAddNewClientIdModal = () => {
        setIsAddNewClientIdModalOpen(false);
        fetchData(1); // Refresh data after adding new client ID
    };
    const cancelAddNewClientIdModal = () => {
        setIsAddNewClientIdModalOpen(false);
    }

    const cancelClientIdModal = () => {
        setIsModalOpen(false);
        setSelectedClient(null);
    }

  // Load the business list so the partner-client-ID table can show a
  // business name instead of a raw id. Skipped if it's already populated.
  useEffect(() => {
    if (!businessList || businessList.length === 0) {
      dispatch(fetchBusinesses({ page: 1, limit: 100 }));
    }
  }, [dispatch, businessList]);

  useEffect(() => {
    const updatedData: PartnerClientId[] = []
    console.log('items partner client ids ', items)
    const businessLookup = businesses ?? businessList ?? []
      ;(items ?? []).forEach((item: PartnerClientId)=> {
      // console.log('business id of clientId object', item.businessId, businesses)
        const business = businessLookup.find((b: any) => b.id === item.businessId);
       // console.log('matched business', business)
        if (business) {
          updatedData.push({ ...item,business: item.businessId, businessId: business.name, usage: `${item.users_count}/${item.users_limit}` });
        } else {
          updatedData.push(item);
        }

      })
      setData(updatedData);
      console.log('partner client ids data', updatedData)
  }, [items, businesses, businessList]);

  const fetchData = async (page: number) => {
    let businessId = undefined
    if (user && user.business && user.business.name != 'elisyan') {
        businessId = user.business.id
    }
    dispatch(fetchPartnerClientIds({ token : user?.token || "",page, limit: itemsPerPage, businessId, startAfterId: page > currentPage ? lastDocId : null }));
  };

  const handleSearch = useCallback((searchTerm?: string) => {
    // let businessId = undefined
    // if (user && user.business && user.business.name != 'elisyan') {
    //     businessId = user.business.id
    // }
    if(user && user.business && searchTerm) {
    dispatch(
      fetchPartnerClientIds({
        token: "",
        businessId: user?.business?.id,
        search: searchTerm || undefined, // undefined triggers paginated fetch
        page: 1,
      })
    );
    }else{
      fetchData(1);
    }
  }, [dispatch]);

  useEffect(() => {
    if(need_client_id){
      fetchData(1);
    }
  }, [need_client_id]);

  const columns = [
    { key: "clientId", label: "Client ID", isSortable: true },
    { key: "type", label: "Type", isSortable: true  },
    { key: "usage", label: "Usage", isSortable: true  },
    { key: "name", label: "Client Name", isSortable: true  },
    
  ];

  if(user && user.business && user.business.name == 'elisyan') {
    columns.push( { key: "businessId", label: "Business", isSortable: true  })
  }
  
  const handleRowClick = (rowData: any) => {
    setSelectedClient(rowData);
    setIsModalOpen(true);
  };

  //*************************************************************************************************//

  useEffect(() => {
    console.log("businesses in side navigation", businesses);
    const userBusiness = businessList.find((business: Business) => business.id === user?.business?.id);
    setUserBusiness(userBusiness || null);
    setNeedClientId((userBusiness?.need_client_id || user?.business?.name === 'elisyan') ? true : false);
  }, [businessList]);
  
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>MANAGE CLIENTS</h2>
       {(need_client_id)?
         <div className={classes.buttonContainer}>
         <CustomButton
           title={"Add New Client ID"}
           handleClick={() => setIsAddNewClientIdModalOpen(true)}
           name={"add-clientId"}
           loading={false}
         />
         {isElisyan &&
            //  <BulkUploadClientIds businesses={businesses}        
            //  />
            <CustomButton
            title={"Manage Client IDs ➡"}
            handleClick={() => navigate('/uploadClientIds', { state: { businesses } })}
            name={"upload-clientIds"}
            loading={false}
          />
    
         }
        
       </div> 
      :
      <div className={classes.buttonContainer}>
      <CustomButton
        title={"Add New Client"}
        handleClick={() => setIsAddNewClientModalOpen(true)}
        name={"add-client"}
        loading={false}
      />
    </div>
      }

      </div>

      <HeaderTabs
        tabs={tabs}
        selectedTab={selectedTab}
        onSelect={setSelectedTab}
      />
      {(selectedTab === "pending" && need_client_id)?(
       <>
       {/* {loading ? (
          <p>Loading...</p>
        ) : ( */}

          {/* <SearchInput
            onSearch={handleSearch}
            placeholder="Search by client ID or name..."
            isSearching={loading}
          /> */}
          <DynamicTable
            columns={withDescriptions(columns, CLIENT_ID_COLUMNS)}
            data={data}
            pagination
            currentPage={page}
            rowStyle={(row) =>
              row.status === "canceled" ? { opacity: 0.45 } : undefined
            }
            renderRowActions={(row) => {
              const isCanceled = row.status === "canceled";
              return (
                <div
                  style={{ display: "flex", gap: 12, alignItems: "center" }}
                  title={isCanceled ? "This client ID has been canceled" : undefined}
                >
                  {isCanceled && (
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        color: "#c62828",
                        letterSpacing: 0.5,
                      }}
                    >
                      Canceled
                    </span>
                  )}
                  <Pencil
                    size={18}
                    style={{
                      cursor: isCanceled ? "not-allowed" : "pointer",
                      opacity: isCanceled ? 0.4 : 1,
                      pointerEvents: isCanceled ? "none" : "auto",
                    }}
                    aria-label="Edit client ID"
                    aria-disabled={isCanceled}
                    onClick={() => {
                      if (isCanceled) return;
                      setSelectedClient(row as PartnerClientId);
                      setIsModalOpen(true);
                    }}
                  />
                  <Ban
                    size={18}
                    color="#c62828"
                    style={{
                      cursor: isCanceled ? "not-allowed" : "pointer",
                      opacity: isCanceled ? 0.4 : 1,
                      pointerEvents: isCanceled ? "none" : "auto",
                    }}
                    aria-label="Cancel client ID"
                    aria-disabled={isCanceled}
                    onClick={() => {
                      if (isCanceled) return;
                      setCancelTarget(row as PartnerClientId);
                    }}
                  />
                </div>
              );
            }}
            itemsPerPage={itemsPerPage}
            onPageChange={fetchData}
            totalPages={total}
            onSearch={handleSearch}
            isSearching={loading}
          />
         {/* )} */}
      </>
      ) : (selectedTab === "pending" && pendingClients) ?(
        <TableComponent
          selectedTab={selectedTab}
          dropdowns={dropdowns}
          columns={withDescriptions(columnsBySelectedTab, PENDING_CLIENT_COLUMNS)}
          data={pendingClients.map((client) => ({
            ...client,
            business_name: normalizeBusinessName(client.business_name),
            client, // Ensure this is correctly passed
          }))}
          handleNavigate={handleClientClick}
        />
      ) : selectedTab === "active" ? (
        <TableComponent
          selectedTab={selectedTab}
          dropdowns={dropdowns}
          columns={withDescriptions(columnsBySelectedTab, CLIENT_COLUMNS)}
          // data={filteredClients.map((client) => ({
          //   ...client,
          //   client, // Ensure this is correctly passed
          // }))}
          data={filteredClients.map((client) => ({
            ...client,

            client, // Ensure this is correctly passed
          }))}
          handleNavigate={handleClientClick}
          // pagination={true}
          // itemsPerPage={10}
        />
      ) : selectedTab === "analytics" && isElisyan ? (
        <ClientsAnalytics
          clients={filteredClients}
          onClientClick={handleClientClick}
        />
      ) : null}

      <AddNewClientModal
        isOpen={isAddNewClientModalOpen}
        onConfirm={confirmAddNewClientModal}
        onCancel={cancelAddNewClientModal}
        role_type="client"
      />
      <ShareAccessCodeClientModal
        isOpen={isShareAccessCodeModalOpen}
        client={pendingClient}
        onConfirm={function (): void {
          throw new Error("Function not implemented.");
        }}
        onCancel={cancelShareAccessCodeModal}
      />

{isAddNewClientIdModalOpen ? 
        <PartnerClientIdModal
        mode="add"
          isOpen={isAddNewClientIdModalOpen}
          onConfirm={confirmAddNewClientIdModal}
          onCancel={cancelAddNewClientIdModal}
        />
        :
        selectedClient && isModalOpen &&(
          <PartnerClientIdModal
            mode="edit"
            hideDelete
            isOpen={isModalOpen}
            existingClientId={ data.filter(clientId => clientId.id == selectedClient.id)[0]}
            onConfirm={() => {
              setIsModalOpen(false);
              setSelectedClient(null);
              fetchData(page); // Refresh data after editing
            }}
            onCancel={() => {
              setIsModalOpen(false);
              setSelectedClient(null);
            }}
          />
        )
    }

      <CancelClientIdModal
        isOpen={Boolean(cancelTarget)}
        target={
          cancelTarget
            ? (data.find((c) => c.id === cancelTarget.id) ?? cancelTarget)
            : undefined
        }
        onConfirm={() => {
          setCancelTarget(null);
          fetchData(page); // Refresh after canceling
        }}
        onCancel={() => setCancelTarget(null)}
      />
      {/* <button onClick={() => setIsRemoveLicenseModalOpen(true)}>
        Remove License
      </button>

      <ConfirmModal
        isOpen={isRemoveLicenseModalOpen}
        onClose={() => setIsRemoveLicenseModalOpen(false)}
        onConfirm={handleRemoveLicense}
        title="Are you sure you want to remove this license?"
        description={
          <>
            The advisor record will also be deleted,
            <br />
            and the license will be available to assign
            <br />
            to a new client or advisor
          </>
        }
        confirmText="Remove License"
      /> */}
    </div>
  );
};

export default Clients;
